import { useMemo, useEffect, useState, useRef } from 'react';
import { ViewMode, Gantt } from "../libs/gantt-task-react";

const GanttChart = ({ tasks, view, viewDate, isChecked, onTaskChange, onTaskDelete, onProgressChange, onDblClick, onClick, onSelect, onRightClick, onExpanderClick, onTaskReorder, rowHeight = 50, columnWidth: customColumnWidth, barFill = 80, columnVisibility, columnOrder, onColumnOrderChange, columnWidths, onColumnWidthsChange, collapsedChains, onChainToggle }) => {
    const ganttFontSize = "12px";
    const ganttFontFamily = '"Inter var"';

    const columnWidth = useMemo(() => {
        // Use custom columnWidth if provided, otherwise use default based on view
        if (customColumnWidth !== undefined && !isNaN(customColumnWidth) && customColumnWidth > 0) {
            return customColumnWidth;
        }
        switch (view) {
            case ViewMode.Year:
                return 350;
            case ViewMode.Month:
                return 100;
            case ViewMode.Week:
                return 70;
            default:
                return 65;
        }
    }, [view, customColumnWidth]);
    const ganttWrapperRef = useRef(null);
    const [ganttHeight, setGanttHeight] = useState(0);
    const groupClassMap = {
        underway: 'rgba(220, 220, 0, 0.2)',
        done: 'rgba(0, 255, 0, 0.2)'
    };

    const updatedTasks = tasks.map(task => {
        let backgroundColor;

        if (task.progress > 0) {
            backgroundColor = groupClassMap["underway"]
        }
        if (task.progress === 100) {
            backgroundColor = groupClassMap["done"]
        }

        return backgroundColor
            ? { ...task, backgroundColor }
            : task;
    });

    function getTextWidth(text, font = `${ganttFontSize} Inter var`) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        if (!context) return 100;
        context.font = font;
        return context.measureText(text).width;
    }

    function getMaxTaskNameWidth(tasks) {
        const font = `${ganttFontSize} Inter var`;
        let maxWidth = 0;
        tasks.forEach(task => {
            // Validate task name to prevent NaN
            const taskName = task.name || '';
            const width = getTextWidth(taskName, font);
            if (!isNaN(width) && width > maxWidth) {
                maxWidth = width;
            }
        });
        return Math.ceil(maxWidth) + 32;
    }

    useEffect(() => {
        const calculateHeight = () => {
            const wrapperTop = ganttWrapperRef.current.getBoundingClientRect().top;
            const availableHeight = window.innerHeight - wrapperTop - 90;
            setGanttHeight(availableHeight);
        };

        calculateHeight();
        window.addEventListener("resize", calculateHeight);
        return () => window.removeEventListener("resize", calculateHeight);
    }, []);

    return (
        <div ref={ganttWrapperRef}>
            <Gantt
                tasks={updatedTasks}
                nameColumnWidth={getMaxTaskNameWidth(tasks)}
                viewMode={view}
                viewDate={viewDate}
                onDateChange={onTaskChange}
                onDelete={onTaskDelete}
                onProgressChange={onProgressChange}
                onDoubleClick={onDblClick}
                onClick={onClick}
                onRightClick={onRightClick}
                onSelect={onSelect}
                onExpanderClick={onExpanderClick}
                onTaskReorder={onTaskReorder}
                listCellWidth={isChecked ? "105px" : ""}
                columnWidth={columnWidth}
                rowHeight={rowHeight}
                barFill={barFill}
                ganttHeight={ganttHeight}
                locale='pl-PL'
                fontFamily={ganttFontFamily}
                fontSize={ganttFontSize}
                todayColor="#656565ff"
                columnVisibility={columnVisibility}
                columnOrder={columnOrder}
                onColumnOrderChange={onColumnOrderChange}
                columnWidths={columnWidths}
                onColumnWidthsChange={onColumnWidthsChange}
                collapsedChains={collapsedChains}
                onChainToggle={onChainToggle}
            />
        </div>
    );
};

export default GanttChart;
